<template>
  <div>
    <unicom-tabela
      :exibirQtItensPagina="qtPaginas > 0"
      iconeMensagemVazia="search"
      mensagemVazia="Nenhum resultado encontrado"
      subtituloMensagemVazia="mostrar todos"
      mostrarNovoBlocoVazio
      alturaMinimaBody="260px"
      :alturaBody="300"
      :icones="[]"
      :itensPorPagina="['5', '10', '15', '20']"
      :itemSelecionadoProp="itemSelecionado"
      :pagina="pagina"
      :qtPaginas="qtPaginas"
      :qtResultados="qtResultados"
      :rows="rows"
      :cabecalho="cabecalho"
      :carregamento="loadingTabela"
      textoExibindo="Resultados"
      contemHover
      @click-subtitulo-mensagem="$refs.filtro.limpar()"
      @click-linha="clickLinha"
      @troca-pagina="trocarPagina"
      @troca-elemento-pagina="trocarElementoPagina"
      @ordena="ordenarColuna"
      class="header-personalizado"
    >
      <div slot="header">
        <unicom-linha espacamento :justificarItem="'end'">
          <unicom-coluna sm="12" md="auto" class="flex-fill">
            <unicom-barra-pesquisa-complete
              :items="listaUnimedOrigem.map(e => e.textoExibicao)"
              v-model="campoPesquisa.descricao"
              @index="selecionarPesquisa"
              @limpar-campos="limparCampoPesquisa"
              placeholder="Buscar por código ou nome da Unimed..."
            />
          </unicom-coluna>
          <unicom-coluna
            sm="12"
            md="auto"
            :class="$breakpoint.smAndDown ? 'mt-2' : ''"
          >
            <unicom-botao
              :bloco="$breakpoint.smAndDown"
              :largura="170"
              @click="mostrarFiltro = true"
              contornado
              nomeIcone="sliders"
              estiloIcone="transform: rotate(90deg);"
            >
              FILTRAR
              <div class="quantidade-filtro" v-if="quantidadeFiltro">
                {{ quantidadeFiltro }}
              </div>
            </unicom-botao>
          </unicom-coluna>
        </unicom-linha>
      </div>
    </unicom-tabela>
    <FiltroValidacao
      ref="filtro"
      v-model="mostrarFiltro"
      :listaStatus="listaStatus"
      :listaUnimedOrigem="listaUnimedOrigem"
      :limparUnimed="limparUnimed"
      :listaAnalistas="listaAnalistas"
      @unimed-limpada="limparUnimed = false"
      @limpar-filtro="limparFiltro"
      @limpar-pesquisa="limparPesquisa"
      @filtrar="filtrar"
      @filtroPuro="obj => (objetoFiltroPuro = obj)"
    />
  </div>
</template>

<script>
import ValidacaoMixin from "../ValidacaoMixin";
import FiltroValidacao from "./FiltroValidacao";

export default {
  mixins: [ValidacaoMixin],
  components: {
    FiltroValidacao
  }
};
</script>
